import { emailRegex, phoneNumberRegex } from "./common";
import i18n from "../lang/i18n";

const validations = {
  student_code: {
    maxLength: 255
  },
  username: {
    required: true,
    maxLength: 50,
    format: {
      valid: value => /^[a-zA-Z0-9_. ]*$/.test(value.trim()),
      message: i18n.t("validation.the_username_cant_contain_special_character")
    }
  },
  password: {
    required: true,
    maxLength: 255,
    minLength: 6
    /* format: {
      valid: value => /^(?=.*?[A-Z])(?=.*?[0-9]).{8,50}$/.test(value.trim()),
      message:
        "The password must have at least 8-50 characters, at least 1 digit(s), at least 1 upper case letter(s)"
    }*/
  },
  /*status: {
    required: true
  },*/
  first_name: {
    required: true,
    maxLength: 255
  },
  middle_name: {
    maxLength: 255
  },
  last_name: {
    required: true,
    maxLength: 255
  },
  phone_number: {
    maxLength: 255,
    format: {
      valid: value => phoneNumberRegex.test(value.trim()),
      message: i18n.t("validation.the_phone_number_must_only_have_digits")
    }
  },
  email: {
    required: true,
    maxLength: 255,
    format: {
      valid: value => emailRegex.test(value.trim()),
      message: i18n.t("validation.the_email_is_invalid")
    }
  },
  street: {
    maxLength: 255
  },
  apartment: {
    maxLength: 255
  },
  state: {
    maxLength: 255
  },
  city: {
    maxLength: 255
  },
  zip: {
    maxLength: 255
  },
  country: {
    maxLength: 255
  }
};

export { validations };
